import React from 'react';

const InviteFriendsContext = React.createContext();
// Context object accepts a displayName string property.
// React DevTools uses this string to determine what to display for the context.
InviteFriendsContext.displayName = 'InviteFriendsContext';

export function useInviteFriendsContext() {
  return React.useContext(InviteFriendsContext);
}

export default InviteFriendsContext;
